import BankAccountRepository from "../repository/bank-account-repository";

class BankAccountService
{
    #bankAccountRepository;

    constructor() {
        this.#bankAccountRepository = new BankAccountRepository();
    }

    async create(bankAccount) {
        try {
            const data = await this.#bankAccountRepository.create(bankAccount);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async edit(bankAccount) {
        try {
            const data = await this.#bankAccountRepository.edit(bankAccount);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async remove(bankAccount) {
        try {
            const data = await this.#bankAccountRepository.remove({id: bankAccount.id});

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findOne(id) {
        try {
            const data = await this.#bankAccountRepository.getOneById(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async gridview(query) {
        try {       
            const data = await this.#bankAccountRepository.gridview(query);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findAll() {
        try {
            const data = await this.#bankAccountRepository.getAll();

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findAllByCompany() {
        try {
            const data = await this.#bankAccountRepository.getAll();

            return data.filter(item => item.party_id === null);
        } catch (error) {
            console.error(error);
        }
    }

    async findAllByPartyId(partyId) {
        try {
            const data = await this.#bankAccountRepository.getAll(partyId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async zeroOutBonCards(destinationBankAccountId, bonCardIds) {
        try {
            const data = await this.#bankAccountRepository.zeroOutBonCards(destinationBankAccountId, bonCardIds);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async chargeBonCards(originBankAccountId, bonCardIds) {
        try {
            const data = await this.#bankAccountRepository.chargeBonCards(originBankAccountId, bonCardIds);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async bonCardTransactions(id, from, to) {
        try {
            const data = await this.#bankAccountRepository.getBonCardTransactions(id, from, to);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async bonCardReceipts(from, to, referenceCode) {
        try {
            const data = await this.#bankAccountRepository.getBonCardReceipts(from, to, referenceCode);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async balance(id) {
        try {
            const data = await this.#bankAccountRepository.getBalance(id);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async transactions(id, from, to) {
        try {
            const data = await this.#bankAccountRepository.getTransactions(id, from, to);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async ibanInfo(iban) {
        try {
            const data = await this.#bankAccountRepository.getIBANInfo(iban);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async diffTransactions(id, from, to) {
        try {
            const data = await this.#bankAccountRepository.getDiffTransactions(id, from, to);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async statements(id, from, to) {
        try {
            const data = await this.#bankAccountRepository.getStatements(id, from, to);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async importTransactions(bankAccount, transactions) {
        try {
            const data = await this.#bankAccountRepository.importTransactions(bankAccount, transactions);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}



export default BankAccountService;